//gameList/actionCreators.js

import actionTypes from './actionTypes';

const gameDataPayloadMeta = (partyKey) => ({
    payload: {
        partyKey
    },
    meta: {
        checkAuth: true,
    }
});

//public actions
const purgeGameData = partyKey => ({
    type: actionTypes.PURGE_GAME_DATA,
    ...gameDataPayloadMeta(partyKey),
});

const requestGameData = partyKey => ({
    type: actionTypes.REQUEST_GAME_DATA,
    ...gameDataPayloadMeta(partyKey),
});

const gameDataResponse = (success, gameData, errors, partyKey, retainBoxscoreFeedDataId) => ({
    type: actionTypes.GAME_DATA_RESPONSE,
    payload: {
        success,
        gameData,
        errors,
        partyKey,
        retainBoxscoreFeedDataId
    }
});

const headerGameDataResponse = (success, gameData, errors, partyKey, retainBoxscoreFeedDataId) => ({
    type: actionTypes.HEADER_GAME_DATA_RESPONSE,
    payload: {
        success,
        gameData,
        errors,
        partyKey,
        retainBoxscoreFeedDataId
    }
});

const requestBoxscoreFeedData = partyKey => ({
    type: actionTypes.REQUEST_BOXSCORE_DATA,
    payload: {
        partyKey
    }
});

const boxscoreFeedDataResponse = (success, boxscoreFeedData, errors, partyKey) => ({
    type: actionTypes.BOXSCORE_DATA_RESPONSE,
    payload: {
        success,
        boxscoreFeedData,
        errors,
        partyKey
    }
});

const setRetainBoxscoreFeedDataId = id => ({
    type: actionTypes.SET_RETAIN_BOXSCORE_DATA_ID,
    payload: {
        retainBoxscoreFeedDataId: id
    }
});

const requestGameDate = partyKey => ({
    type: actionTypes.REQUEST_GAME_DATE,
    payload: {
        partyKey
    }
});

const gameDateResponse = (success, gameDate, errors, partyKey) => ({
    type: actionTypes.GAME_DATE_RESPONSE,
    payload: {
        success,
        gameDate,
        errors,
        partyKey
    }
});

const requestLandingData = () => ({
    type: actionTypes.REQUEST_LANDING_DATA
});

const landingDataResponse = (summary) => ({
    type: actionTypes.LANDING_DATA_RESPONSE,
    payload: {
        summary
    }
});

const requestRightRailData = () => ({
    type: actionTypes.REQUEST_RIGHT_RAIL_DATA
});

const rightRailDataResponse = (gameInfo) => ({
    type: actionTypes.RIGHT_RAIL_DATA_RESPONSE,
    payload: {
        gameInfo
    }
});

export default {
    requestGameData,
    gameDataResponse,
    headerGameDataResponse,
    purgeGameData,
    requestBoxscoreFeedData,
    boxscoreFeedDataResponse,
    setRetainBoxscoreFeedDataId,
    requestGameDate,
    gameDateResponse,
    requestLandingData,
    landingDataResponse,
    requestRightRailData,
    rightRailDataResponse
};
